export default "__VITE_ASSET__DxxYwoDt__"